export const ADD_SINGLE_ASSESSMENT = 'ADD_SINGLE_ASSESSMENT';
export const REMOVE_SINGLE_ASSESSMENT = 'REMOVE_SINGLE_ASSESSMENT';
export const  ASSESSMENT_QUESTONS_RESULT = ' ASSESSMENT_QUESTONS_RESULT'
export const  GET_ERRORS_FOR_STARTED_QUESTIONS = 'GET_ERRORS_FOR_STARTED_QUESTIONS'
export const GET_ASSESSSMENT_QUESTIONS = 'GET_ASSESSSMENT_QUESTIONS'
export const ADD_ASSESSSMENT_QUESTION = 'ADD_ASSESSSMENT_QUESTION'
